const cleanName = (value) => String(value || "").trim().replace(/\s+/g, " ");

export const getPosBankChanges = (original = [], current = []) => {
  const originalById = new Map(original.map((bank) => [bank.id, bank]));
  const currentById = new Map(current.map((bank) => [bank.id, bank]));
  const added = [];
  const reactivated = [];
  const deactivated = [];
  const renamed = [];

  current.forEach((bank) => {
    const previous = originalById.get(bank.id);
    if (!previous && bank.attiva !== false) added.push(cleanName(bank.nome));
    if (previous?.attiva === false && bank.attiva !== false) reactivated.push(cleanName(bank.nome));
    if (previous?.attiva !== false && bank.attiva === false) deactivated.push(cleanName(previous.nome));
    if (previous && (cleanName(previous.nome) !== cleanName(bank.nome) || (previous.abbreviazione || "") !== (bank.abbreviazione || ""))) {
      renamed.push(`${cleanName(previous.nome)} (${previous.abbreviazione || "—"}) → ${cleanName(bank.nome)} (${bank.abbreviazione || "—"})`);
    }
  });

  original.forEach((bank) => {
    if (!currentById.has(bank.id) && bank.attiva !== false) deactivated.push(cleanName(bank.nome));
  });

  return {
    added,
    reactivated,
    deactivated,
    renamed,
    hasChanges: added.length + reactivated.length + deactivated.length + renamed.length > 0,
  };
};

export const buildPosBankConfirmation = (changes) => {
  const parts = [];
  if (changes.added.length) parts.push(`Attivare: ${changes.added.join(", ")}.`);
  if (changes.reactivated.length) parts.push(`Riattivare: ${changes.reactivated.join(", ")}.`);
  if (changes.renamed.length) parts.push(`Rinominare: ${changes.renamed.join(", ")}.`);
  if (changes.deactivated.length) parts.push(`Disattivare: ${changes.deactivated.join(", ")}.`);
  parts.push("Lo storico non viene riassegnato automaticamente. Se questa è la prima banca, dopo il salvataggio potrai scegliere se collegare i POS Generici.");
  return parts.join(" ");
};